module.exports = __webpack_public_path__ + "static/media/mushroomchickencroustade.527190e2.jpg";